<template>
  <div class="header">
    <div class="system-name" @click="backHome">某数据智能检索软件</div>
    <div class="header-right">
      <!-- <div class="info-type" @click="changeSystemType" v-show="isShowField"> -->
      <div class="info-type" v-show="isShowField" @click="changeSystemType">
        <!-- <el-button type="primary" @click="changeSystemType"> -->
        {{ $store.getters.getSystemType }}
        <!-- </el-button> -->
      </div>
      <MenuButtionList
        :menu-list="menuList"
        class="menu-list"
      ></MenuButtionList>
      <div class="logout">
        <i
          class="el-icon-user-solid"
          size="large"
          title="退出登录"
          @click="logOut"
        ></i>
      </div>
    </div>
    <!-- <el-menu
      :default-active="activeIndex"
      class="menu-list"
      mode="horizontal"
      background-color="transparent"
      text-color="#1E6C7D"
      active-text-color="#E85D24"
      @select="handleSelect"
    >
      <template v-for="item in menuList">
        <el-menu-item :key="item.index" :index="item.index" v-if="item.children.length === 0">
          {{ item.name }}
        </el-menu-item>
        <el-submenu :key="item.index" :index="item.index" v-else>
          <template slot="title">
            {{ item.name }}
          </template>
          <el-menu-item v-for="child in item.children" :key="child.index" :index="child.index">
            {{ child.name }}
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu> -->
  </div>
</template>

<script>
import MenuButtionList from "@/components/MenuButtonList";
import navList from "@/modules/navList";
export default {
  components: {
    MenuButtionList,
  },
  data() {
    return {
      activeIndex: "1",
      menuList: null,
    };
  },
  computed: {
    navLevel: function () {
      return this.$store.state.menuLevel;
    },
    isShowField: function () {
      return this.navLevel === 1 ? false : true;
    },
  },
  watch: {
    navLevel: {
      handler(newVal) {
        this.menuList =
          newVal === 1 ? navList.topMenuList : navList.secondaryMenuList;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /**
     * 切换海洋信息，电磁空间
     */
    changeSystemType() {
      if (this.$store.getters.getSystemType === "海洋信息") {
        this.$store.commit("setSystemType", "电磁空间");
      } else {
        this.$store.commit("setSystemType", "海洋信息");
      }
    },
    handleSelect(item) {
      let indexList = item.split("-");
      let currentMenuItem = this.menuList[Number(indexList[0]) - 1];

      this.$router.push(currentMenuItem.path);
      // if (indexList.length > 1) {
      //   setTimeout(() => {
      //     this.$router.push(currentMenuItem.children[Number(indexList[1]) - 1].path)
      //   }, 10)
      // }
    },
    //返回首页
    backHome() {
      if (this.navLevel !== 1) {
        this.$router.push("/SearchEngine");
        this.$store.commit("setMenuLevel", 1);
      }
    },
    /**
     * 退出登录
     */
    logOut() {
      this.$router.push("/Login");
      this.$message.info("退出登录");
      this.$store.commit("setIsLogin", false);
    },
  },
};
</script>

<style lang="scss">
$fontColor: #eee;
$fontColorHighlight: rgb(156, 156, 75);
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
.header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #101c45;
  box-shadow: 0 0 1.5em $innerLight inset;
  justify-content: space-between;

  .system-name {
    font-size: 24px;
    padding: 0 20px;
    // font-weight: bold;
    color: $fontColor;
    cursor: pointer;
  }
  .header-right {
    display: flex;
    & > .logout {
      line-height: 55px;
      font-size: 16px;
      padding: 0 20px;
      // font-weight: bold;
      color: $fontColor;
      cursor: pointer;
      &:hover {
        color: $fontColorHighlight;
      }
    }
  }
  .menu-list {
    // position: absolute;
    right: 1.5vw;
    // top: 0;
    // bottom: 0;
  }
  .info-type {
    line-height: 55px;
    font-size: 16px;
    padding: 0 20px;
    // font-weight: bold;
    color: $fontColor;
    cursor: pointer;
    // user-select: none;
  }
}
</style>
